import styled from 'styled-components';

// Caixa de texto com limite de linhas (line-clamp).
// Quando "expanded", remove o limite e mostra tudo.
export const Clamped = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${props => (props.expanded ? 'unset' : props.maxLines)};
  ${props => props.expanded ? '' : 'overflow: hidden;'}

  /* Nome do remetente em destaque (laranja) */
  .sender {
    color: ${props => (props.isUser ? 'rgb(255, 184, 79)' : 'rgb(255, 153, 0)')};
    font-weight: 700;
    margin-right: 4px;
  }
`;

export const ReadMoreButton = styled.button`
  display: inline-block;
  margin-top: 4px;
  background: transparent;
  border: none;
  padding: 0;
  /* Verde: não conflita com o laranja do "pensamento" dos personagens */
  color: rgb(80, 200, 120);
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    color: rgb(110, 220, 150);
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid rgb(80, 200, 120);
    outline-offset: 2px;
    border-radius: 2px;
  }
`;
